import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { API_DELETE_USER } from "../../../config/api";
import { getAllUser } from "./management";

export const deleteUser = createAsyncThunk(
  "user/delete",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "DELETE",
        path: `${API_DELETE_USER}${payload?.payload}`,
      });

      toast.success('User Successfuly Deleted')
      payload.callback()

      dispatch(getAllUser());
      return response?.data;
    } catch (error) {
      //const msg = proccessErrorMessage(error);
      toast.error(error);
      return rejectWithValue(error.message);
    }
  }
);
